export default "__VITE_ASSET__Cf3UUSac__"